import { render, staticRenderFns } from "./budgetInfo.vue?vue&type=template&id=102a35bb&scoped=true&"
import script from "./budgetInfo.vue?vue&type=script&lang=js&"
export * from "./budgetInfo.vue?vue&type=script&lang=js&"
import style0 from "./budgetInfo.vue?vue&type=style&index=0&id=102a35bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a35bb",
  null
  
)

export default component.exports